import React, { useEffect, useState } from 'react';

const MiniSparkline = ({ color }) => {
  const [pts, setPts] = useState(() => Array.from({ length: 20 }, () => Math.random() * 100));
  useEffect(() => {
    const i = setInterval(() => {
      setPts((p) => [...p.slice(1), Math.max(15, Math.min(95, p[p.length - 1] + (Math.random() - 0.5) * 35))]);
    }, 600);
    return () => clearInterval(i);
  }, []);
  const d = pts.map((v, i) => `${(i / (pts.length - 1)) * 100},${100 - v}`).join(' ');
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-4">
      <polyline points={d} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: `drop-shadow(0 0 2px ${color})` }} />
    </svg>
  );
};

export default MiniSparkline;
